// Oráculo dos 12 Raios Constants
// Centralized configuration for maintainability

// Oracle Flow Steps
export const ORACLE_STEPS = {
  FIRST_STEP: 6,           // Oracle flow starts from ray selection
  MASTER_REVIEW_STEP: 16,  // Final review step
  TOTAL_DISPLAY_STEPS: 11, // Steps 1-11 displayed to user (maps to steps 6-16)
  PROGRESS_OFFSET: 5       // Offset for progress calculation: displayStep = step - 5
};

// Animation Timings (milliseconds)
export const ANIMATIONS = {
  CARD_REVEAL_DURATION: 800,     // Card selection reveal animation
  SPLASH_MOVE_DURATION: 800,     // Mouse move splash animation
  SPLASH_CLICK_DURATION: 1000,   // Click splash animation
  SCROLL_DELAY: 100,             // Delay before smooth scroll
  API_MOCK_DELAY: 1500,          // Mock API response delay
  STEP_TRANSITION_DURATION: 1000 // Fade transition between Oracle steps
};

// Form Validation
export const VALIDATION = {
  MIN_PASSWORD_LENGTH: 6,        // Minimum password length
  QUESTION_MAX_PREVIEW: 100      // Max characters for question preview
};

// MagicalBackground Configuration
export const MAGICAL_BACKGROUND = {
  PARTICLE_COUNT: 0,             // No particles - removed per boss request
  ORB_COUNT: 3,                  // Number of mystical orbs
  PARTICLE_BASE_DURATION: 16,    // Base animation duration for particles (unused now)
  PARTICLE_DURATION_VARIANCE: 8, // Random variance for particle duration (unused now)
  MAX_ANIMATION_DELAY: 10        // Maximum random animation delay (seconds)
};

// Claude API Configuration
export const CLAUDE_API = {
  MAX_TOKENS_DECREE: 100,        // Token limit for decree generation
  MAX_TOKENS_DEFAULT: 300,       // Token limit for other content
  WORD_LIMITS: {
    BLOCKAGE: '100-150',         // Word count for blockage text
    SOLUTION: '100-150',         // Word count for solution text
    WISDOM: '80-120',            // Word count for wisdom text
    DECREE: '20'                 // Word count for decree text (maximum)
  }
};

// Selection Types
export const SELECTION_TYPES = {
  DIAGNOSIS: 'diagnosis',
  DIAGNOSIS_ELEMENT: 'diagnosisElement', 
  SOLUTION: 'solution',
  SOLUTION_ELEMENT: 'solutionElement'
};

// Card Counts
export const CARD_COUNTS = {
  TYPE_CARDS: 9,                 // Number of type cards (diagnosis/solution)
  ELEMENT_CARDS: 4,              // Number of element cards
  RAY_COUNT: 12                  // Number of mystical rays
};

// Theme System Configuration
export const THEME_CONFIG = {
  SCROLL_BEHAVIOR: 'instant',    // Scroll behavior for step transitions
  SCROLL_TOP_DELAY: 0,           // Delay before scroll to top (ms)
  
  // Available themes for Phase 2
  AVAILABLE_THEMES: [
    'basic',
    'masculine-heart',
    'feminine-heart', 
    'masculine-wealth',
    'feminine-wealth',
    'masculine-purpose',
    'feminine-purpose',
    'masculine-neutral',
    'feminine-neutral',
    'universal-heart',
    'universal-wealth',
    'universal-purpose'
  ],
  
  // Scrollbar configuration per theme
  SCROLLBAR_STYLES: {
    WIDTH: '12px',
    BORDER_RADIUS: '10px',
    TRANSITION_DURATION: '0.2s'
  }
};